import merge from 'lodash/merge';
import GA from 'public/helpers/MyGA';
import * as actions from './types';
import service from './service';

const fetchList = (search, dispatch) =>
  service
    .fetchList(search)
    .then(response => dispatch({ type: actions.FETCH_LIST, data: response.data }));

const getNewSearch = (search, getState) => {
  const { form, sort, page } = getState().StudentSurvey;
  return merge({}, { form, sort, page }, search);
};

const creators = {
  sortChange: sort =>
    async (dispatch, getState) => {
      dispatch({ type: actions.SORT_CHANGE, sort });
      return fetchList(getNewSearch({ sort }, getState), dispatch);
    },
  pageChange: page =>
    async (dispatch, getState) => {
      dispatch({ type: actions.PAGE_CHANGE, page });
      return fetchList(getNewSearch({ page }, getState), dispatch);
    },
  searchFormSubmit: form =>
    async (dispatch, getState) => {
      // console.log('searchFormSubmit', form, dispatch);
      dispatch({ type: actions.SEARCH_FORM_SUBMIT, form });
      return fetchList(getNewSearch({ form, page: 0 }, getState), dispatch);
    },

  fetchOne: id =>
    async (dispatch) => {
      const response = await service.fetchOne(id, '?expand=class,questionnaire.sections.items');
      dispatch({ type: actions.FETCH_ONE, model: response.data });
      GA.event({ category: 'Student Survey', action: 'Load Survey', label: `Load Survey ${response.data.name}` });
      return response.data;
    },

  clearOne: () =>
    async dispatch => dispatch({ type: actions.CLEAR_ONE }),
};

export default creators;
